
<div class="w-100 d-flex news-feed " data-aos="fade-down"
    data-aos-delay="100">
    <div class="bar-head blink_">
        <em class="bx bx-broadcast"></em> 
    </div>

    <em class="bar-text w-100"><marquee scrollamount="5">{{newsfeed}}</marquee></em>
     
</div>
